export default __webpack_public_path__ + "static/media/launching-soon-icon.e9f09ae1.svg";